import api from './api'
import moment from 'moment'
import authHeader from './auth-header';

class AppointmentTokenService {
    async get(params = {}) {
        return api.get('/appointment-token', {'params': params}, authHeader()).then(response => response.data);
    }

    async create(appointmentToken, account) {
        const dateStart = moment(appointmentToken.date_start)
        const dateEnd = moment(appointmentToken.date_end)

        return api.post('/account/' + account + '/appointment-token', {
            account_uuid: account,
            status: 0,
            valid: true,
            date_start: dateStart.format('YYYY-MM-DD'),
            date_end: dateEnd.format('YYYY-MM-DD'),
            duration: appointmentToken.duration,
            reason_id: appointmentToken.reason_id,
            place_id: appointmentToken.place_id,
            person_uuid: appointmentToken.person_uuid,
            email: appointmentToken.email,
        })
        .then(response => response.data);
    }
}

export default new AppointmentTokenService();
